import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './CartList.css';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeFromCart, setAmount } from '../../redux/cartSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import { useState } from 'react';
import {
    formatIkeaCatalogRetailSummary,
    getMultipackDisplayRows,
    isIkeaMultipackCartItem,
} from '../../utils/cartMultipackDisplay';
import { ClipLoader } from 'react-spinners';
import { formatMoney } from '../../utils/formatMoney';
import { ikeaImageSrc } from '../../utils/ikeaImage';

const CartList = ({ data, showcase, editing, update, printing, creditnote, noMargin = false, embed = false, stockLoading = false }) => {
    const [mobile, setMobile] = useState(false);
    let navigate = useNavigate();
    const dispatch = useDispatch()

    const rootClass = ['cartlist-v2', printing ? 'cartlist-v2--printing' : '']
        .filter(Boolean)
        .join(' ');

    const formatSkuDisplay = (raw) => {
        if (raw == null) return '';
        const s = String(raw);
        if (s.length > 20) return s;
        return s.replace(/(\d{3})(?=\d)/g, '$1.');
    };

    const handleChange = (event, id) => {
        event.preventDefault();

        if (editing) {
            update(data.map(x => {
                if (x.id === id) return {...x, amount: event.target.value}
                else return x;
            }));
        } else {
            dispatch(setAmount({
                id: id,
                amount: event.target.value,
            }));
        }
    }

    const handleCreditChange = (event, id) => {
        event.preventDefault();

        update(data.map(x => {
            if (x.id === id) return {...x, creditAmount: event.target.value}
            else return x;
        }));
    }

    const remove = (id) => {
        if (editing) {
            update(data.filter(x => x.id !== id));
        } else {
            dispatch(removeFromCart({
                id: id,
            }));
            toast.error('Removed item from cart.')
        }
    }

    useEffect(() => {
        const screenwidth = window.innerWidth;
        if (screenwidth < 600) {
            setMobile(true);
        } else {
            setMobile(false);
        }
    }, [])

    const tableBlock = (
            <div className={rootClass}>
            <TableContainer component={Paper} elevation={0} className="cartlist-v2__surface">
                <Table sx={(printing || mobile) ? {maxWidth: mobile ? window.innerWidth : 444} : {minWidth: 650}} aria-label="Cart items" style={{ minWidth: '100%' }}>
                    <TableHead>
                        <TableRow className="cartlist-v2__head-row">
                            <TableCell className="cart-cell cart-cell-thumb cart-cell-nopadding" aria-hidden />
                            {creditnote && <TableCell className="cart-cell cart-cell-narrow cart-cell-nopadding" />}
                            <TableCell className="cart-cell">Name</TableCell>
                            <TableCell className="cart-cell cart-cell--numeric">Price</TableCell>
                            <TableCell className="cart-cell cart-cell--qty">Quantity</TableCell>
                            <TableCell className="cart-cell cart-cell--numeric">Total</TableCell>
                            {(!showcase || editing) && <TableCell className="cart-cell cart-cell-remove" />}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => {
                            const multipack =
                                isIkeaMultipackCartItem(row) ? getMultipackDisplayRows(row) : null;
                            return (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                className="cart-row"
                            >
                                <TableCell component="th" scope="row" className="cart-cell cart-cell-thumb cart-cell-nopadding" onClick={() => navigate(`/product/${row.id}`)}>
                                    <img className="cart-thumb" src={ikeaImageSrc(row.img || row.thumbUrl)} alt="" loading="lazy" />
                                </TableCell>
                                {creditnote && <TableCell component="th" scope="row" className="cart-cell cart-cell-narrow cart-cell-nopadding">
                                    <input
                                        type="number"
                                        className="cartlist-qty-input"
                                        min={0}
                                        max={row.amount}
                                        value={row.creditAmount || 0}
                                        onChange={(e) => handleCreditChange(e, row.id)}
                                    />
                                </TableCell>}
                                <TableCell className="cart-cell cart-cell-details">
                                    <span className="cartlist-title-link" onClick={() => navigate(`/product/${row.id}`)}>{row.name}</span><br></br>
                                    {row.description && (<><small className="cartlist-desc">{row.description}</small><br></br></>)}
                                    <small className="cartlist-meta">SKU: {row.SKU ? row.SKU : row.id.length > 20 ? row.id : formatSkuDisplay(row.id)}</small>
                                    {multipack && multipack.lines.length > 0 && (
                                        <div className="cart-multipack">
                                            <div className="cart-multipack-summary">
                                                {multipack.packageCount} package
                                                {multipack.packageCount !== 1 ? 's' : ''} in this article
                                            </div>
                                            <ul className="cart-multipack-list">
                                                {multipack.lines.map((ln) => (
                                                    <li key={`${ln.sku}-${ln.ordinal}`} className="cart-multipack-li">
                                                        <span className="cart-multipack-idx">#{ln.ordinal}</span>
                                                        <span className="cart-multipack-body">
                                                            {ln.name ? <span className="cart-multipack-name">{ln.name} · </span> : null}
                                                            <span className="cart-multipack-sku">SKU {formatSkuDisplay(ln.sku)}</span>
                                                            {ln.colli > 1 ? (
                                                                <span className="cart-multipack-colli"> · ×{ln.colli} colli</span>
                                                            ) : null}
                                                            {ln.ikeaCatalogDisplay ? (
                                                                <span className="cart-multipack-price">
                                                                    {' '}
                                                                    ·{' '}
                                                                    {formatIkeaCatalogRetailSummary(
                                                                        ln.ikeaCatalogDisplay,
                                                                    )}
                                                                </span>
                                                            ) : null}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {!multipack &&
                                        Array.isArray(row.packageLines) &&
                                        row.packageLines.length > 0 && (
                                            <div className="cart-package-lines cart-package-lines--legacy">
                                                {row.packageLines.map((pl) => (
                                                    <div key={pl.sku} className="cart-package-line">
                                                        <small>
                                                            {pl.name ? `${pl.name} · ` : ''}
                                                            SKU: {formatSkuDisplay(pl.sku)} × {pl.qty}
                                                            {pl.catalogUnitPrice != null &&
                                                            Number.isFinite(Number(pl.catalogUnitPrice)) ? (
                                                                <> · IKEA €{formatMoney(pl.catalogUnitPrice)}</>
                                                            ) : null}
                                                        </small>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                </TableCell>
                                <TableCell className="cart-cell cart-cell--numeric">€{formatMoney(row.price)}</TableCell>
                                <TableCell className="cart-cell cart-cell--qty">
                                    <div className="cartlist-qty-stack">
                                        {!showcase || editing ? <input
                                            type="number"
                                            className="cartlist-qty-input"
                                            min={1}
                                            value={row.amount || row.quantity}
                                            onChange={(e) => handleChange(e, row.id)}
                                        /> : row.amount || row.quantity}
                                        {stockLoading && !printing && String(row.id).length <= 20 && (
                                            <div className="cartlist-stock-loading">
                                                <ClipLoader color="#C4603C" size={14} speedMultiplier={0.85} />
                                                <small>Checking stock…</small>
                                            </div>
                                        )}
                                        {!stockLoading && (row.stock === null || row.stock === undefined) && !printing && (
                                            <small className="cartlist-stock-muted">No stock info available.</small>
                                        )}
                                        <div>
                                            {!stockLoading && row.stock != null && row.stock !== undefined && !printing ? 
                                            (<div className="cartlist-stock-block">
                                            <small className="cartlist-stock-count">{row.stock} items in stock.</small>
                                            <br></br>
                                            {row.probability === 'HIGH_IN_STOCK' 
                                            ? <small className="v2-stock--high">High in stock.</small> 
                                            : row.probability === 'LOW_IN_STOCK' ? 
                                            <small className="v2-stock--low">Low items remaining.</small>
                                            : <small className="v2-stock--out">Out of stock!</small>}
                                            </div>) : null}
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell className="cart-cell cart-cell--numeric cart-cell-total">€{formatMoney(row.price * (row.amount || row.quantity))}</TableCell>
                                {(!showcase || editing) && (
                                    <TableCell className="cart-cell cart-cell-remove cart-cell-nopadding">
                                        <button
                                            type="button"
                                            className="cartlist-remove"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                remove(row.id);
                                            }}
                                            aria-label={`Remove ${row.name} from cart`}
                                        >
                                            ×
                                        </button>
                                    </TableCell>
                                )}
                            </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
    );

    if (embed) {
        return <div className="v2-mui-scope cartlist-embed">{tableBlock}</div>;
    }

    return (
        <Container maxWidth='lg' className={noMargin ? "p-0" : printing ? "mt-0 p-0" : "mt-50 p-0"}>
            {tableBlock}
        </Container>
    );
};

export default CartList